// Le vocabulaire des types de RÈGLEMENT — côté front.
//
// 🔴 CE N'EST PAS UN TROISIÈME JEU DE STATUTS, et la distinction compte : pas
// de machine à états, pas de dérivation, aucune sémantique de couleur (la
// pastille est `primary` quel que soit le type). C'est un VOCABULAIRE
// d'habillage. C'est pourquoi la garde `H1c`, qui surveille les
// `*_STATUS_META`, reste silencieuse ici — à juste titre.
//
// 🔴 IL ÉTAIT ÉCRIT CINQ FOIS DANS TROIS FICHIERS : la liste autorisée du
// serveur, plus la table des libellés ET les 5 `<MenuItem>` de chacun des deux
// écrans de paiement. Aucune ne divergeait — c'est ce qui rendait la situation
// dangereuse : rien n'aurait signalé la première divergence.
//
// ⚠️ LA SOURCE EST `backend/constants/payment_type.py`, et une garde vérifie
// que les DEUX listes sont identiques, dans le même ORDRE. Le serveur refuse
// en 400 tout code hors liste : un front qui proposerait un sixième choix
// produirait un refus que l'utilisateur ne pourrait pas comprendre.

export const PAYMENT_TYPE = {
  ESPECES: 'especes',
  CHEQUE: 'cheque',
  VIREMENT: 'virement',
  CARTE: 'carte',
  AUTRE: 'autre',
};

// Métadonnées d'affichage : clé i18n seulement — même forme que
// `PAYMENT_STATUS_META`, sans `colorKey` puisqu'aucune couleur ne distingue
// les types.
export const PAYMENT_TYPE_META = {
  [PAYMENT_TYPE.ESPECES]: { i18nKey: 'payments.cash' },
  [PAYMENT_TYPE.CHEQUE]: { i18nKey: 'payments.check' },
  [PAYMENT_TYPE.VIREMENT]: { i18nKey: 'payments.transfer' },
  [PAYMENT_TYPE.CARTE]: { i18nKey: 'payments.card' },
  [PAYMENT_TYPE.AUTRE]: { i18nKey: 'payments.other' },
};

// L'ORDRE DES MENUS, du plus courant au moins courant. Il est le même que
// `ALL` côté serveur, et la garde le vérifie — le changer d'un seul côté
// réordonnerait un menu sans qu'aucun test ne tombe.
export const TYPES_REGLEMENT_ORDONNES = [
  PAYMENT_TYPE.ESPECES,
  PAYMENT_TYPE.CHEQUE,
  PAYMENT_TYPE.VIREMENT,
  PAYMENT_TYPE.CARTE,
  PAYMENT_TYPE.AUTRE,
];

// Le choix pré-sélectionné — il était écrit en dur SIX fois, trois par écran.
export const TYPE_REGLEMENT_DEFAUT = PAYMENT_TYPE.VIREMENT;

/**
 * Le libellé d'un type, traduit.
 *
 * ⚠️ LE REPLI SUR LE CODE BRUT EST DÉLIBÉRÉ, ET IL N'OUVRE PAS LA LISTE. La
 * liste est fermée PAR LE SERVEUR ; ce repli sert aux données DÉJÀ ÉCRITES —
 * si le vocabulaire changeait un jour, un paiement enregistré sous l'ancien
 * code doit rester lisible plutôt que d'afficher un vide. *Un écran qui
 * n'affiche rien pour une valeur qu'il ne connaît pas fait croire à une
 * donnée manquante.*
 */
export const libelleTypeReglement = (code, t) => {
  const meta = PAYMENT_TYPE_META[code];
  return meta ? t(meta.i18nKey) : code;
};
